// Session cache for the engine catalog (#4483): module scope lives as long
// as the SPA session, so navigation back into the section renders the
// engine list immediately instead of re-fetching behind a placeholder.
import type { EngineSkill } from '../../types/api'

let catalogCache: EngineSkill[] | null = null

export function getCatalogCache(): EngineSkill[] | null {
  return catalogCache
}

export function setCatalogCache(skills: EngineSkill[]): void {
  catalogCache = skills
}

// Test-only: the module-scope cache survives between tests in one file.
export function __resetCatalogCacheForTests(): void {
  catalogCache = null
}
